export { defineTool } from "./types.js";

export type {
  AgentHarness,
  HarnessEvent,
  HarnessSystemEvent,
  HarnessSystemInitEvent,
  HarnessCompactBoundaryEvent,
  HarnessTaskStartedEvent,
  HarnessTaskProgressEvent,
  HarnessAssistantEvent,
  HarnessContentBlock,
  HarnessResultEvent,
  HarnessResultSuccessEvent,
  HarnessResultErrorEvent,
  HarnessRateLimitEvent,
  HarnessToolProgressEvent,
  HarnessUserMessage,
  HarnessToolDefinition,
  HarnessToolAnnotations,
  HarnessMcpServer,
  HarnessQueryOptions,
  HarnessHookInput,
  HarnessHookOutput,
  HarnessPostToolUseHook,
  PtyBridge,
} from "./types.js";

export { ClaudeCodeHarness } from "./claude-code/index.js";
export { PtyHarness } from "./pty/index.js";

import { ClaudeCodeHarness } from "./claude-code/index.js";
import { PtyHarness } from "./pty/index.js";
import type { AgentHarness, PtyBridge } from "./types.js";

export type HarnessKind = "sdk" | "pty";

/**
 * Pick the harness implementation. `ptyBridge` is only consumed by the PTY
 * harness (to stream stdout to the S2 relay and receive keystrokes/resize);
 * the SDK harness ignores it.
 */
export function createHarness(kind: HarnessKind = "sdk", ptyBridge?: PtyBridge): AgentHarness {
  return kind === "pty" ? new PtyHarness(ptyBridge) : new ClaudeCodeHarness();
}
